// Naming convention: Present tense verbs, all lowercase. Does not include ">" character.
export default {
  click: 'click',
  clickButton: 'click button',
  clickClickableText: 'click clickable text',
  completeStep: 'complete step',
  navigateTo: 'navigate to',
  linkAccount: 'link account',
  selectInstitution: 'select institution',
  linkOrAddAccounts: 'link or add accounts',
  failedToLinkAccounts: 'failed to link accounts',
  showModal: 'show modal',
  completed: 'completed',
  header: 'header',
  question: 'question',
  insight: 'insight',
  preliminaryResults: 'preliminary results',
  contactForm: 'contact form',
  contactFormIntro: 'contact form intro',
  processCreditCard: 'process credit card',
  resizeSection: 'resize section',
  changePicklist: 'change picklist',
  toggleSwitch: 'toggle switch',
  dragAndDrop: 'drag and drop',
  updateSmartInsight: 'update smart insight',
  deleteSmartInsight: 'delete smart insight',
  openAccount: 'open account clicked',
  pendingAccountClick: 'pending account click',
  fullScreen: 'full screen',
  edit: 'edit',
  suggestion: 'suggestion',
  expandGoal: 'expandGoal',
  confirmModelUpdates: 'confirm model updates',
  selectPath: 'select path',
  compare: 'compare',
  chat: 'chat',
  page: 'page',
};
